import React, { Component } from 'react';
import { BrowserRouter } from "react-router-dom";
import { Route, Switch } from "react-router-dom";

import './App.css';

import UploadPostmanCollectionPage from "./containers/UploadPostmanCollectionPage";
import SwaggerUIPage from "./containers/SwaggerUIPage";
import SwaggerUIPagePublic from './containers/SwaggerUIPagePublic';
import SelfServePageService from './containers/SelfServePage';
import uploadYamlFilePage from "./containers/UploadYamlFilePage";


class App extends Component {
  state = {
    response: '',
    post: '',
    responseToPost: '',
    serviceEndpointListing: [],

    // swaggerui module based state
    organizationName: "Myntra",
    definitionLink: "https://run.mocky.io/v3/eb95ddfa-7f0e-4077-b499-2bac32ea069d",
    selfServeDisabled: false
  };

  handleSubmit = async e => {
    e.preventDefault();
    const response = await fetch('/api/world', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ post: this.state.post }),
    });
    const body = await response.text();
    
    this.setState({ responseToPost: body });
  };

  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Switch>
            <Route path="/" exact component={SwaggerUIPagePublic} />
            <Route path="/internal" exact component={SwaggerUIPage}/>
            <Route path="/uploadPostmanCollection" exact component={UploadPostmanCollectionPage}/>
            <Route path="/uploadYamlFile" exact component={uploadYamlFilePage} />
            {<Route path="/selfserve" render={(props) => <SelfServePageService disabled={this.state.selfServeDisabled}/>}/>}
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
